// Validation utilities for forms

// Email regex matches backend constraint: valid_email CHECK
// See: backend/schema.sql lines 1359, 3307, 5987 (priv.credentials, priv.manager_invitation, priv.validation_code)
export const EMAIL_VALIDATION_PATTERN = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/i;

export const PASSWORD_MIN_LENGTH = 8;
